import User from "./modules/user";
import Common from "./modules/common";
import Errormessage from "./modules/errormessage";
import BillingStore from "./modules/billingStore";
import PrivilegeStore from "./modules/privilege";
import ValidateStore from "./modules/privilegeValidate";

const privilegeStore = new PrivilegeStore();
export default {
  userStore: new User(),
  commonStore: new Common(),
  errorStore: new Errormessage(),
  billingStore: new BillingStore(),
  privilegeStore,
  validateStore: new ValidateStore(privilegeStore),
};
